module.exports = __webpack_public_path__ + "img/TagAmMeer.d626aa39.jpg";